import state from '~store/modules/data/state'
import actions from '~store/modules/data/actions'

export default {
  state,
  actions
}
